import { Injectable } from '@angular/core';
import { initialize, getInAppMessages, DisplayOptions } from '@iterable/web-sdk';
import { SosApiService } from '../api/api.service';

@Injectable({ providedIn: 'root' })
export class IterableService {
  private iterableInstance: any;
  private initialized = false;

  constructor(private api: SosApiService) {}

  /**
   * Initialize the Iterable SDK without JWT
   */
  init(apiKey: string) {
    if (this.initialized) return;

    this.iterableInstance = initialize(apiKey);

    this.initialized = true;
    console.log('Iterable SDK initialized without JWT');
  }

  /**
   * Identify a user by email
   */
  async identify(email: string) {
    if (!email) {
      console.warn('Email missing, skipping identification.');
      return;
    }

    try {
      const response = await fetch(
        'https://api.iterable.com/api/users/update',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Api-Key': 'ba19ddcfdc514924bf368db042c2fea3'
          },
          body: JSON.stringify({
            email: email
          })
        }
      );

      const data = await response.json();
      console.log('Iterable user identified:', data);

    } catch (err) {
      console.warn('Iterable identify skipped:', err);
    }
  }

  public async registerBrowserToken(email: string, token: string) {
    if (!token || !email) {
      console.warn('Token or email missing, skipping registration.');
      return;
    }

    try {
      const response = await fetch(
        'https://api.iterable.com/api/users/registerBrowserToken',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Api-Key': 'ba19ddcfdc514924bf368db042c2fea3'
          },
          body: JSON.stringify({
            email,
            browserToken: token
          })
        }
      );

      const data = await response.json();
      console.log('Iterable token registered:', data);

    } catch (err) {
      console.warn('Iterable registration skipped:', err);
    }
  }
}